(() => {
  if (customElements.get('wk-featured-carousel')) return;

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (!window.wkFeaturedSwiperPromise) {
      window.wkFeaturedSwiperPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        script.onload = () => resolve(window.Swiper);
        script.onerror = () => {
          script.remove();
          window.wkFeaturedSwiperPromise = null;
          reject(new Error('WK Featured Carousel: Swiper could not load.'));
        };
        document.head.append(script);
      });
    }
    return window.wkFeaturedSwiperPromise;
  }

  customElements.define('wk-featured-carousel', class extends HTMLElement {
    async connectedCallback() {
      const lifecycle = new AbortController();
      this.lifecycle?.abort();
      this.lifecycle = lifecycle;
      try {
        const Swiper = await loadSwiper();
        if (!this.isConnected || lifecycle.signal.aborted) return;
        this.carousel = new Swiper(this.querySelector('.swiper'), {
          slidesPerView: 2,
          spaceBetween: 12,
          breakpoints: { 700: { slidesPerView: 4, spaceBetween: 24 } },
          speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 350,
          watchOverflow: true,
          navigation: {
            prevEl: this.querySelector('.wk-featured__arrow--prev'),
            nextEl: this.querySelector('.wk-featured__arrow--next')
          },
          a11y: { enabled: true }
        });
        this.classList.add('is-ready');
        this.addEventListener('shopify:block:select', event => {
          const index = Array.from(this.querySelectorAll('[data-block-id]'))
            .findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.carousel.slideTo(index);
        }, { signal: lifecycle.signal });
      } catch (error) {
        // The horizontal scroll fallback remains usable if the CDN is unavailable.
        console.warn(error);
      }
    }

    disconnectedCallback() {
      this.lifecycle?.abort();
      this.carousel?.destroy(true, true);
      this.carousel = null;
      this.classList.remove('is-ready');
    }
  });
})();
